import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Home from "./pages/Home";
import VCI from "./pages/VCI";
import NDVI from "./pages/NDVI";
import ETA from "./pages/Evapotranspiration";
import LandCover from "./pages/LandCover";
import WeatherMonitoring from "./pages/WeatherMonitoring";
import Precipitation from "./pages/Precipitation";
import PrecipitationMonthly from "./pages/Precipitation-monthly";
import LandDegradation from "./pages/LandDegradation";

import ReloadHandler from "./RelaodHandler";

import store from "./store/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import ResetPass from "./pages/PasswordReset";
import "react-toastify/dist/ReactToastify.css";
import VHI from "./pages/VHI";
import Masking from "./pages/Masking";
import Reporting from "./pages/Masking/reporting";
import ASI from "./pages/ASI";
import Prediction from "./pages/Prediction";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./components/Theme";
import SPI1 from "./pages/SPI-1";
import SPI2 from "./pages/SPI-2";
import SPI3 from "./pages/SPI-3";
import SPI6 from "./pages/SPI-6";
import SPI9 from "./pages/SPI-9";
import SPI12 from "./pages/SPI-12";
import AdminHomePage from "./pages/Home/AdminPanel";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import AuthPage from "./components/Sign/SignModal";
import EmailVerification from "./pages/EmailVerification";
import AccountActivation from "./pages/AccountActivation";
import useTokenValidator from "./hooks/checkAuth";
import ProtectedRoute from "./components/ProtectedRoute";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/account",
    element: <AuthPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/verify/:token",
    element: <EmailVerification />,
  },
  {
    path: "/activate/:token",
    element: <AccountActivation />,
  },
  {
    path: "/admin/*",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "VCI",
    element: (
      <ProtectedRoute>
        <VCI />
      </ProtectedRoute>
    ),
  },
  {
    path: "vegetation-monitoring/:type/:index",
    element: (
      <ProtectedRoute>
        <NDVI />
      </ProtectedRoute>
    ),
  },
  {
    path: "map",
    element: (
      <ProtectedRoute>
        <NDVI />
      </ProtectedRoute>
    ),
  },
  {
    path: "Evapotranspiration",
    element: (
      <ProtectedRoute>
        <ETA />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "land-degredation-monitoring/:type/:index",
  //   element: <LandCover />,
  // },
  {
    path: "land-monitoring/:type/:index",
    element: (
      <ProtectedRoute>
        <LandCover />
      </ProtectedRoute>
    ),
  },
  {
    path: "Weather-Monitoring",
    element: (
      <ProtectedRoute>
        <WeatherMonitoring />
      </ProtectedRoute>
    ),
  },
  {
    path: "weather-monitoring/:type/:index",
    element: (
      <ProtectedRoute>
        <Precipitation />
      </ProtectedRoute>
    ),
  },
  {
    path: "Precipitation-monthly",
    element: (
      <ProtectedRoute>
        <PrecipitationMonthly />
      </ProtectedRoute>
    ),
  },
  {
    path: "VHI",
    element: (
      <ProtectedRoute>
        <VHI />
      </ProtectedRoute>
    ),
  },
  {
    path: "ASI",
    element: (
      <ProtectedRoute>
        <ASI />
      </ProtectedRoute>
    ),
  },
  {
    path: "resetpassword/:reset_token",
    element: <ResetPass />,
  },
  {
    path: "monitoring",
    element: (
      <ProtectedRoute>
        <Masking />
      </ProtectedRoute>
    ),
  },
  {
    path: "reporting",
    element: (
      <ProtectedRoute>
        <Reporting />
      </ProtectedRoute>
    ),
  },
  {
    path: "prediction",
    element: (
      <ProtectedRoute>
        <Prediction />
      </ProtectedRoute>
    ),
  },
  {
    path: "land-degradation",
    element: (
      <ProtectedRoute>
        <LandDegradation />
      </ProtectedRoute>
    ),
  },
  {
    path: "drought-monitoring/:type/:index",
    element: (
      <ProtectedRoute>
        <SPI1 />
      </ProtectedRoute>
    ),
  },
  {
    path: "SPI-2",
    element: (
      <ProtectedRoute>
        <SPI2 />
      </ProtectedRoute>
    ),
  },
  {
    path: "SPI-3",
    element: (
      <ProtectedRoute>
        <SPI3 />
      </ProtectedRoute>
    ),
  },
  {
    path: "SPI-6",
    element: (
      <ProtectedRoute>
        <SPI6 />
      </ProtectedRoute>
    ),
  },
  {
    path: "SPI-9",
    element: (
      <ProtectedRoute>
        <SPI9 />
      </ProtectedRoute>
    ),
  },
  {
    path: "SPI-12",
    element: (
      <ProtectedRoute>
        <SPI12 />
      </ProtectedRoute>
    ),
  },
]);
function App() {
  // useTokenValidator();
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ReloadHandler />
        <RouterProvider router={router} />
        <ToastContainer
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999 }}
        />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
